/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import styles from 'components/pages/support/help/helpStyles'
import { useFormatMessage } from 'lib/localization'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

function ConfigureMxRecordsI18n({ classes }: { classes: ReturnType<typeof styles> }) {
  const formatMessage = useFormatMessage('ess.help_configure_mx_records')
  return (
    <div className={classes.content} data-testid="content" style={{ height: '100%' }}>
      <p>
        <b>{formatMessage('intro')}</b>
      </p>
      <p>{formatMessage('note')}</p>
      <ol style={{ listStyleType: 'decimal' }}>
        <li>
          {formatMessage('steps.step_1')}
          <br />
          <small>{formatMessage('steps.step_1_note')}</small>
        </li>
        <li>
          {formatMessage('steps.step_2')}
          <br />
          <small>{formatMessage('steps.step_2_note')}</small>
        </li>
        <li>
          {formatMessage('steps.step_3')}
          <br />
          <small>{formatMessage('steps.step_3_note')}</small>
        </li>
        <li>
          {formatMessage('steps.step_4')}
          <br />
          <small>{formatMessage('steps.step_4_note')}</small>
        </li>
        <li>
          {formatMessage('steps.step_5')}
          <br />
          <small>{formatMessage('steps.step_5_note')}</small>
        </li>
        <li>
          {formatMessage('steps.step_6')}
          <br />
          <small>{formatMessage('steps.step_6_note')}</small>
        </li>
      </ol>
    </div>
  )
}

const ConfigureMxRecords = () => {
  const classes = styles()
  let isSmartlingEnabled = false
  try {
    isSmartlingEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    // Default to OFF when called outside Redux context (e.g., renderToString for search)
  }

  // Flag ON: Use translated content
  if (isSmartlingEnabled) {
    return <ConfigureMxRecordsI18n classes={classes} />
  }

  // Flag OFF: Original hardcoded English content
  return (
    <div className={classes.content} data-testid="content" style={{ height: '100%' }}>
      <p>
        <b>
          Before using Email Gateway Defense, you must modify your domain's MX records to point to Barracuda Networks'
          mail servers. MX records direct your email traffic and are stored by your domain's DNS provider.
        </b>
      </p>
      <p>
        Note: You must modify all of your MX records to point to Barracuda Networks' mail servers. If any of your MX
        records point to servers other than Barracuda Networks', that can interfere with Barracuda Networks' ability to
        protect your domain(s) from threats and spam.
      </p>
      <ol style={{ listStyleType: 'decimal' }}>
        <li>
          Click a domain name to expand the table row and expose its MX record information.
          <br />
          <small>You will need this information in Step 4 below.</small>
        </li>
        <li>
          Sign in to your domain's DNS provider account.
          <br />
          <small>DNS providers include companies such as GoDaddy and Enom.</small>
        </li>
        <li>
          In your DNS provider account, locate the page for updating your domain's DNS records.
          <br />
          <small>It might be called something like DNS Zone File, Name Server Management, or Advanced Settings.</small>
        </li>
        <li>
          Replace the existing MX records in the DNS provider account with the ones you exposed in Step 1 above.
          <br />
          <small>You will need this information in Step 4 below.</small>
        </li>
        <li>
          Save your changes and wait for the new settings to take effect.
          <br />
          <small>Updating MX records can take up to 48 hours.</small>
        </li>
        <li>
          Repeat this step for all of your Domains
          <br />
          <small>
            It is essential for threat and spam prevention that you follow this procedure for all of your domains.
          </small>
        </li>
      </ol>
    </div>
  )
}

export default ConfigureMxRecords
